import React from 'react'
import Instagram from './instagram'

import './index.css'

const Social = () => (
  <div>
    <h3>Connect your social accounts to give Blue Robot access.</h3>
    <div className='row' style={{ paddingTop: '25px' }}>
      <Instagram />
    </div>
  </div>
)

Social.displayName = 'Social'

export default Social



// WEBPACK FOOTER //
// ./src/pages/profile-settings/social/index.js